import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';

/**
 * Configurações → manutenção: copia a alocação da Solicitação pras Movimentações que ainda não
 * têm alocação própria (sincronizarAlocacaoMovimentacoesSi). Roda uma vez depois do deploy da
 * alocação por Movimentação; rodar de novo não muda nada (só toca quem ainda não tem).
 */
export default function SincronizarAlocacoesButton() {
  const toast = useToast();
  const queryClient = useQueryClient();
  const [rodando, setRodando] = useState(false);

  const sincronizar = async () => {
    if (!window.confirm('Copiar a alocação de cada Solicitação pras Movimentações que ainda não têm alocação própria?')) return;
    setRodando(true);
    try {
      const fn = httpsCallable<void, { movimentacoesAtualizadas: number }>(getFunctions(), 'sincronizarAlocacaoMovimentacoesSi');
      const { movimentacoesAtualizadas } = (await fn()).data;
      toast.success(
        movimentacoesAtualizadas === 0
          ? 'Tudo já estava sincronizado.'
          : `${movimentacoesAtualizadas} Movimentação(ões) receberam a alocação da Solicitação.`
      );
      queryClient.invalidateQueries({ queryKey: ['si'] });
    } catch (erro: any) {
      toast.error(`Não foi possível sincronizar: ${erro?.message || 'erro desconhecido'}`);
    } finally {
      setRodando(false);
    }
  };

  return (
    <div className="rounded-md border border-dashed border-gray-300 px-4 py-3">
      <p className="font-montserrat font-medium text-gray-900">Alocação das Movimentações</p>
      <p className="mt-0.5 text-sm text-gray-500">
        Manutenção: copia a alocação da Solicitação pras Movimentações antigas. Rodar uma vez depois do deploy.
      </p>
      <button type="button" className="btn-secondary mt-2 text-sm" disabled={rodando} onClick={sincronizar}>
        {rodando ? 'Sincronizando...' : 'Sincronizar alocações'}
      </button>
    </div>
  );
}
